import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { SessionService } from '../../../../../@core/utils/session.service';
import { Carrier } from '../../../../modules/pick-plan/models/carrier';
import { TruckType } from '../../../../modules/pick-plan/models/truck-type';
import { truckTypeService } from '../../../../modules/pick-plan/services/truck-type.service';

@Component({
  selector: 'carrier-edit-list',
  templateUrl: './carrier-edit-list.component.html',
  styleUrls: ['./carrier-edit-list.component.scss']
})
export class CarrierEditListComponent implements OnInit {

  //#region Properties
  public editActive = false;
  public carrierLoading = true;
  public editCarrier: Carrier = {};
  public editTruck: TruckType = {};
  public truckTypes: TruckType[] = [];
  public submitting = false;
  private destroyRef = inject(DestroyRef);
  //#endregion

  //#region Constructor with Dependencies  
  constructor(
    private errorService: ErrorService,
    public dialogRef: MatDialogRef<any>,
    private session: SessionService,
    public truckTypeService: truckTypeService
  ) {}
  //#endregion

  ngOnInit() {
    this.editCarrier = this.session.selectedCarrier || { isActive: true };
    this.editTruck = this.session.selectedTruck || { isActive: true };
    this.carrierLoading = false;
    this.loadTruckTypes();
  }

  private loadTruckTypes() {
    this.truckTypeService.getTruckTypes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      {next:(data) => {
        this.truckTypes = data;
      },
      error:(err) => {
        this.errorService.handleError(err);
      }}
    );
  }

  cancelClicked(form: NgForm, cancelled: boolean = false) {
    this.editActive = false;
    this.editCarrier = {};
    form.resetForm();
    this.dialogRef.close(cancelled);
  }

  saveCarrierClicked(form: NgForm) {
    if (!this.editCarrier.id) {
      this.editCarrier.isActive = true;

      // Close right away and let the list component perform the actual
      // create in the background.
      this.dialogRef.close({
        backgroundSave: true,
        isNew: true,
        carrier: { ...this.editCarrier }
      });
      return;
    }

    // Close right away and let the list component perform the actual
    // update in the background.
    this.dialogRef.close({
      backgroundSave: true,
      isNew: false,
      carrier: { ...this.editCarrier }
    });
  }

  truckChanged(id: number) {
    this.editTruck = this.truckTypes.find((x) => x.id === id);
    this.editCarrier.truckTypeId = this.editTruck.id;
    this.editCarrier.truckType = this.editTruck;
  }
}
